export const indirectEval = eval
export function evaluateAccessor(item: any, accessor: string): string | number | boolean | null {
  try {
    if (!accessor || !item) return null
    // Check if the accessor is a function string
    if (accessor.includes('=>') || accessor.startsWith('function')) {
      if (accessor.includes('async')) throw new Error('async accessors are not supported')
      // Create a safe function from the string
      const safeFunction = new Function(
        'item',
        `
        try {
          const result = (${accessor})(item);
          if (Array.isArray(result)) {
            return result.every(item => typeof item === 'string')
              ? result.join(', ')
              : JSON.stringify(result);
          }
          if (typeof result === 'object' && result !== null) {
            return JSON.stringify(result);
          }
          return result;
        } catch (error) {
          return null;
        }
      `,
      )
      return safeFunction(item)
    } else {
      // Handle dot notation
      const result = accessor
        .split('.')
        .reduce((obj, key) => (obj && typeof obj === 'object' && key in obj ? obj[key] : null), item)

      if (Array.isArray(result)) {
        return result.every((item) => typeof item === 'string') ? result.join(', ') : JSON.stringify(result)
      }
      if (typeof result === 'object' && result !== null) {
        return JSON.stringify(result)
      }
      return result
    }
  } catch (error) {
    console.error(`Error evaluating accessor: ${accessor}`, error)
    return null
  }
}

export function loadRemoteScriptWithCtx(scriptUrl: string, context: Record<string, any> = {}) {
  return fetch(scriptUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to load script: ${response.status}`)
      }
      return response.text()
    })
    .then((scriptContent) => {
      const executeScript = new Function('context', scriptContent)
      return executeScript(context)
    })
    .catch((error) => {
      console.error('Script loading/execution error:', error)
    })
}
